import { searchClient } from '@/common/apis/client';
import { ServerStateKeysEnum } from '@/common/apis/serverStateKeysEnum';
import useCustomize from '@/common/hooks/useCustomize';
import { useQuery } from '@tanstack/react-query';
import { normalizeSearchRoute } from './route';

export interface Params {
  query?: any;
  route: string;
  headers?: any;
  timeout?: number;
}

export const search = async ({ route, query, headers, timeout }: Params) => {
  const { data } = await searchClient.get(`/seapi/v1/search/${encodeURI(normalizeSearchRoute(route))}`, {
    params: {
      ...query,
    },
    headers,
    timeout,
  });
  return data;
};

export const useSearch = ({ route, query }: Params, option?: any) => {
  const university = useCustomize(state => state.customize?.partnerKey);

  const searchParams = {
    route,
    query: {
      ...query,
      ...(university && { university }),
    },
  };

  return useQuery([ServerStateKeysEnum.Search, searchParams], () => search(searchParams), {
    keepPreviousData: true,
    refetchOnMount: false,
    ...option,
  });
};

export interface PartnerSubstituteParams {
  city_en_slug: string;
  university: string;
  expertise_slug: string;
}

export const partnerSubstituteSearch = async ({ city_en_slug, university, expertise_slug }: PartnerSubstituteParams) => {
  const city = city_en_slug || 'ir';
  const { data } = await searchClient.get(
    `/seapi/v1/search/${encodeURIComponent(city)}/${encodeURIComponent(expertise_slug)}`,
    {
      params: {
        university,
        ref: 'hospital_team_substitution',
      },
    },
  );
  return data;
};

export const usePartnerSubstituteSearch = (params: PartnerSubstituteParams, option?: any) => {
  return useQuery(
    [ServerStateKeysEnum.Search, 'partner-substitute', params],
    () => partnerSubstituteSearch(params),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      ...option,
    },
  );
};